<template>
  <div>
    소셜 로그인 확인용 테스트 페이지 입니다
    <div>provider : {{ provider }}</div>
  </div>
</template>
<script>
// import { KAKAO_TOKEN } from '@/store/types'
export default {
  name: 'Oauth2',
  data() {
    return {
      provider: this.$route.params.provider,
      token: this.$route.query.token,
      type: this.$route.query.type,
      id: this.$route.query.id,
      withdrawalDate: this.$route.query.withdrawalDate,
      previousUrl: ''
    }
  },
  async mounted() {
    this.create()
    this.previousPath()
    // this.$router.push({ name: 'store' })
  },
  computed: {
    daysUntilRejoin() {
      const dateStr = this.withdrawalDate
      if (!dateStr) return 0
      const base = new Date(dateStr.split(' ')[0]) // "yyyy-MM-dd"
      const deadline = new Date(base)
      deadline.setDate(deadline.getDate() + 30)

      const today = new Date()
      today.setHours(0, 0, 0, 0)
      deadline.setHours(0, 0, 0, 0) // 정확한 날짜 비교를 위해 자정으로 맞춤

      return Math.max(0, Math.ceil((deadline - today) / 86400000))
    }
  },
  methods: {
    create() {
      let tk = this.token
      localStorage.setItem('token', tk)
    },
    previousPath() {
      switch (this.type) {
        case 'EXISTING_USER':
          this.$router.push('/')
          break
        case 'LINKABLE_USER':
          alert('sns 로그인 연동이 완료되었습니다.')
          this.$router.push('/')
          break
        case 'NEW_USER':
          this.$router.push({
            name: 'join_step1',
            query: { type: this.type, id: this.id }
          })
          break
        case 'WITHDRAWN_USER':
          alert(
            `이미 탈퇴된 번호입니다. 탈퇴 후 30일 동안은 재가입이 불가능합니다.\n 남은 기간: ${this.daysUntilRejoin}일`
          )
          this.$router.push({ name: 'sign_up' })
          break
        default:
          alert('잘못된 접근입니다.')
          this.$router.push('/')
      }
    }
  }
}
</script>
